<div class="material-page">
  <h1 i18n class="mat-headline-1">Logging in, should take just a second...</h1>
  <div class="spinner">
    <mat-spinner [diameter]="100"></mat-spinner>
  </div>
</div>